import _ from 'lodash';

import { default as SendThirdPartyEmailItem } from 'actions/composition/send_third_party_email';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import htmlToText from 'models/conversation_item/html_to_text';

export default class SendThirdPartyEmail {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, content }) {
    const composition = getCompositionsStore(this.context).findBy({ id: compositionId });
    if (!composition) {
      return;
    }

    const compositionContent = composition.toJs().content;
    _.forEach(content, (html, attr) => {
      compositionContent[attr] = html;
    });

    compositionContent.bodyPlain = content.bodyPlain || htmlToText(compositionContent.bodyHtml);

    this.context.executeAction(SendThirdPartyEmailItem, {
      compositionId,
      content: compositionContent,
    });
  }
}
